export default __webpack_public_path__ + "static/media/osai-logo-light.a7a8bcfa.png";